<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { isMobile } from 'mobile-device-detect'
import { clone, filter, isEmpty } from 'lodash'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  components: {
    SingleSelectInput,
  },
  props: {
    value: Boolean, // for v-model
    showReset: Boolean,
    filterOptions: Array,
    allowMultiple: Boolean,
  },
  data() {
    return {
      openPanels: [],
      isMobile: isMobile,
      appliedFilters: {},
      selectedFilters: {},
      disableDateTypeWatcher: false,
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getDateType() {
      if (!isEmpty(this.selectedFilters.date_type)) {
        return this.selectedFilters.date_type.type
      }
      return false
    },
    filteredOptions() {
      return this.filterOptions.filter(
        ({ identifier }) => identifier !== 'date',
      )
    },
    filteredDateOptions() {
      const dateOptions = this.filterOptions.find(
        ({ identifier }) => identifier === 'date',
      )

      if (dateOptions) {
        return dateOptions.properties.filter(
          ({ type }) => type === this.selectedFilters.date_type.type,
        )
      }

      return []
    },
    enableFilterButton() {
      return Object.values(this.selectedFilters).some(value => {
        if (Array.isArray(value)) {
          return value.length > 0
        }

        return value !== null
      })
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.restoreFilters()
      }
    },
    selectedFilters: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true,
    },
    'selectedFilters.date_type'(val, oldval) {
      const appliedDateType = this.appliedFilters?.date_type
      if (val && oldval !== val) {
        if (val !== appliedDateType || !this.disableDateTypeWatcher) {
          this.$set(
              this.selectedFilters, 'date',
              this.filteredDateOptions[0],
          )
        } else {
          this.disableDateTypeWatcher = false
        }
      }
    },
  },
  methods: {
    filterResults(identifier, props) {
      return filter(props, i => i.type === this.getDateType)
    },
    restoreFilters() {
      // If previous applied filters exist use them
      if (this.appliedFilters && Object.keys(this.appliedFilters).length > 0) {
        this.disableDateTypeWatcher = true
        this.selectedFilters = clone(this.appliedFilters)
      } else {
        this.reset()
      }
    },
    reset() {
      this.appliedFilters = {}
      this.selectedFilters = {}
      for (const filter of this.filterOptions) {
        const defaultValue = this.allowMultiple ? [] : null
        this.$set(this.selectedFilters, filter.identifier, defaultValue)
      }
      this.$emit('reset')
    },
    apply() {
      const cleaned = Object.fromEntries(
        Object.entries(this.selectedFilters).filter(([
_,
value,
]) =>
          Array.isArray(value) ? value.length > 0 : true,
        ),
      )
      this.appliedFilters = clone(this.selectedFilters)
      this.$emit('apply', cleaned)
    },
    onResultUpdate(args) {
      this.$set(this.selectedFilters, 'date', args)
    },
  },
}
</script>
